import Seo from "@/components/Seo";
import { Section, Container, Btn } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";

export default function ThankYou() {
  return (
    <>
      <Seo title="Thank you" canonical="/thank-you" description="Thank you for reaching out to Prox." />
      <Section bg="bone" className="min-h-[70vh] flex items-center">
        <Container size="md" className="!px-0">
          <div className="max-w-2xl">
            <Eyebrow>Received</Eyebrow>
            <h1 className="t-display2">Thank you. That has reached us.</h1>
            <p className="t-lead mt-6 text-[var(--muted)]">Prox reads everything personally and will reply, usually within a business day. If it is time-sensitive, book a free call and pick the soonest slot.</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Btn to="/book" variant="clay">Book a fit call</Btn>
              <Btn to="/insights" variant="outline">Read the insights</Btn>
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
}
